export const styles = {
  error: 'tw-text-sm tw-text-red-600',
  grid: 'tw-grid tw-grid-cols-1 tw-gap-2',
};
